import * as React from 'react';
import { Card, LineItemBundleRow } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const CardGlassesConfiguration = ({ bundleChildLineItems , bundleConfiguration  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React.createElement(Card.Section, null, bundleConfiguration && /*#__PURE__*/ React.createElement(LineItemBundleRow, {
        body: bundleConfiguration.name,
        currency: intl.currency,
        discountedPrice: bundleConfiguration.discountedPrice,
        originalPrice: bundleConfiguration.originalPrice,
        priceIsZeroLabel: intl.getLabel('cart.lineItem.glasses.isIncluded', {
            hideLabelKey: true
        })
    }), bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.map((item, i)=>/*#__PURE__*/ React.createElement(LineItemBundleRow, {
            key: `${item.name}-${i}`,
            body: item.name,
            currency: intl.currency,
            discountedPrice: item.discountedPrice,
            originalPrice: item.originalPrice,
            priceIsZeroLabel: intl.getLabel('cart.lineItem.glasses.isIncluded', {
                hideLabelKey: true
            }),
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${item.productType}`)
        })
    ));
};

export { CardGlassesConfiguration };
//# sourceMappingURL=CardGlassesConfiguration.js.map
